import { Component, input, model, output } from '@angular/core';
import { LinkComponent } from 'src/app/controls/components/basic/link/link.component';

@Component({
  selector: 'app-onboarding-accordian',
  standalone: true,
  imports: [LinkComponent],
  templateUrl: './onboarding-accordian.component.html',
  styleUrl: './onboarding-accordian.component.scss'
})
export class OnboardingAccordianComponent {
  isOpen = model.required<boolean>();
  disabled = input.required<boolean>();
  openedChange = output<boolean>();

  toggle() {
    if (this.disabled()) return;
    this.isOpen.set(!this.isOpen());
    this.openedChange.emit(this.isOpen());
  }
}


